<template>
    <aside class="aside-menu">
        <Callout class="m-0 py-2 text-center bg-light text-uppercase">
            <b-media>
                <a href="http://profi-planet.org" target="_blank" class="logo">
                    <b-img left width="35" height="35" src="../assets/img/profi_planet_logo.png" alt="Profi-Planet.org" />
                    <b>Profi-Planet</b>
                </a>
            </b-media>
        </Callout>
        <hr class="transparent mx-3 my-0">
        <Callout variant="warning" class="m-0 py-2 text-center bg-light text-uppercase">
            <b-media>
                <a href="http://profi-planet.org" target="_blank" class="logo">
                    <b-img left width="35" height="35" src="../assets/img/profi_post_logo.png" alt="Profi-Post.org" />
                    <b>Profi-Post</b>
                </a>
            </b-media>
        </Callout>
    </aside>
</template>

<script>
    import Callout from './Callout.vue'

    export default {
        name: 'aside',
        components: {
            Callout
        }
    }
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// Aside.vue?4b0a4a6b